import { createContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Location } from 'history';

import { useContextFallback } from '../hooks';

const LocationHistoryContext = createContext<
  { locations: Location[] } | undefined
>(undefined);
LocationHistoryContext.displayName = 'LocationHistoryContext';

export const LocationHistoryProvider: React.FC = ({ children }) => {
  const history = useHistory();
  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    const unregister = history.listen((location) => {
      setLocations((prevState) => [...prevState, location]);
    });

    return () => {
      unregister();
    };
  }, [history]);

  return (
    <LocationHistoryContext.Provider value={{ locations }}>
      {children}
    </LocationHistoryContext.Provider>
  );
};

export const useLocationHistory = () =>
  useContextFallback(LocationHistoryContext).locations;
